import React, { FC, ReactElement } from 'react';
import { GeneralIcons } from '@bluebeam/react-skyline';
import ChevronLeft from '../components/Icons/ChevronLeft';

interface Props {
  backURL: string;
  title: string;
}

const ArgoxAppHeader: FC<Props> = ({ backURL, title }) => {
  return (
    <header
      className="d-flex flex-row items-center justify-start pos-r"
      css={{
        height: '3rem',
        boxShadow: '0 5px 20px 0 rgba(220, 223, 227, .5)',
        zIndex: 2,
      }}
    >
      <div
        role="presentation"
        className="d-flex items-center justify-center mx-3 cursor-pointer h-6"
        css={{
          width: '2rem',
          color: '#0074CC',
        }}
        onClick={() => {
          window.location.assign(backURL);
        }}
      >
        <ChevronLeft />
      </div>

      <div
        className="h-6 shrink-0"
        css={{
          borderRightStyle: 'solid',
          borderRightWidth: '.5px',
        }}
      />
      <div className="ml-3" css={{ width: '1.5rem' }}>
        <GeneralIcons.LabIcon size="24px" />
      </div>
      <div
        className="items-center ml-2"
        css={{
          fontSize: '.875rem',
          color: '#373D42',
        }}
      >
        {title ? (
          <>
            <span>{title}</span>
          </>
        ) : (
          <>Loading ... </>
        )}
      </div>
    </header>
  );
};

export default ArgoxAppHeader;
